import { useEnabledField, useSoundField } from '../../../form'
import { FormKeys } from '../../../form/constants'
import NotificationToggleItem from '../NotificationToggleItem'
import React, { FC } from 'react'
import { useTranslation } from 'react-i18next'

interface OrderAwaitingAcceptanceToggleItemProps {
    disabled: boolean
}

const OrderAwaitingAcceptanceToggleItem: FC<OrderAwaitingAcceptanceToggleItemProps> = ({
    disabled,
}) => {
    const { t } = useTranslation()

    const [enabled, setEnabled] = useEnabledField(FormKeys.OrderAwaitingAcceptance)
    const [sound, setSound] = useSoundField(FormKeys.OrderAwaitingAcceptance)

    return (
        <NotificationToggleItem
            label={t('settings.notifications.field.orderAwaitingAcceptance.label')}
            description={t('settings.notifications.field.orderAwaitingAcceptance.description')}
            checked={enabled}
            onChange={setEnabled}
            disabled={disabled}
            sound={sound}
            onSoundChange={setSound}
        />
    )
}

export default OrderAwaitingAcceptanceToggleItem
